__turbopack_context__.v({
  "button": "Plan-module__eIxF4a__button",
  "buttons": "Plan-module__eIxF4a__buttons",
  "buyPrice": "Plan-module__eIxF4a__buyPrice",
  "card": "Plan-module__eIxF4a__card",
  "costs": "Plan-module__eIxF4a__costs",
  "description": "Plan-module__eIxF4a__description",
  "disabled": "Plan-module__eIxF4a__disabled",
  "features": "Plan-module__eIxF4a__features",
  "icon": "Plan-module__eIxF4a__icon",
  "link": "Plan-module__eIxF4a__link",
  "nominalPrice": "Plan-module__eIxF4a__nominalPrice",
  "nominalPriceWrapper": "Plan-module__eIxF4a__nominalPriceWrapper",
  "plan": "Plan-module__eIxF4a__plan",
  "planBrief": "Plan-module__eIxF4a__planBrief",
  "presentational": "Plan-module__eIxF4a__presentational",
  "price": "Plan-module__eIxF4a__price",
  "prices": "Plan-module__eIxF4a__prices",
  "promo": "Plan-module__eIxF4a__promo",
  "ribbon": "Plan-module__eIxF4a__ribbon",
  "selected": "Plan-module__eIxF4a__selected",
  "unavailable": "Plan-module__eIxF4a__unavailable",
  "unavailableOverlay": "Plan-module__eIxF4a__unavailableOverlay",
});
